<div class="settings-modal-dialog__wrapper">
  <div class="settings-modal-dialog__top">
    <h1 mat-dialog-title class="header">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <i class="i-18 mr-10 fas fa-hdd"></i>
          <span class="fs-18">System</span>
        </div>
        <div>
          <button trgButton class="dialog-close-btn" (click)="close()">
            <i class="fal fa-times i-12 p-relative ot-1"></i>
          </button>
        </div>
      </div>
    </h1>
    <div *ngIf="systemInfo()" mat-dialog-content class="main-body">
      <table class="fs-12">       
        <tr>
          <td class="field-label bold">OPTIMIZE INSIGHTS&#8482; Version:</td>
          <td class="field-value">{{systemInfo().insightsVersion}}</td>
        </tr>
        <tr>
          <td class="field-label bold">Region:</td>
          <td class="field-value">{{systemInfo().region}}</td>
        </tr>
        <tr>
          <td class="field-label bold">Company:</td>
          <td class="field-value">{{systemInfo().companyName}}</td>
        </tr>
        <tr>
          <td class="field-label bold">Company Name:</td>
          <td class="field-value">{{systemInfo().companyLongName}}</td>
        </tr>        
        <tr>
          <td class="field-label bold">Copyright:</td>
          <td class="field-value">
            <a href="{{systemInfo().copyrightUrl}}" target="_blank">
              Click here for Copyright notices
            </a>
          </td>
        </tr>
        <tr>
          <td class="field-label bold">For assistance go to OPTIMIZE INSIGHTS&#8482; Online Support:</td>
          <td class="field-value"><a href="https://support.trgscreen.com" target="_blank">support.trgscreen.com</a></td>
        </tr>
        <tr>
          <td class="field-label bold">Privacy Statement:</td>
          <td class="field-value"><a href="https://www.trgscreen.com/privacy-policy" target="_blank">privacy-policy</a></td>
        </tr>
      </table>
    </div>
    <div *ngIf="loading()" class="min-h-200 d-flex align-items-center justify-content-center">
      <app-spinner></app-spinner>
    </div>
    <div *ngIf="error()" mat-dialog-content class="main-body">
      <p>
        Unable to obtain system information, please contact support for assistance
      </p>
    </div>
  </div>
  <div mat-dialog-actions align="end" class="settings-modal-dialog__bottom">
    <button trgButton color="primary" class="min-w-100" (click)="close()">Close</button>
  </div>
</div>
